module.exports = __webpack_public_path__ + "img/card-i5.4aac6208.png";